<template>
  <b-link :href="link ? link : '#'" v-b-tooltip.hover :title="message">
    <b-icon
      :icon="icon ? icon : 'exclamation-triangle-fill'"
      :variant="variant ? variant : 'warning'"
      :animation="animation ? animation : 'fade'"
    ></b-icon>
  </b-link>
</template>

<script>
export default {
  props: ["link", "message", "icon", "variant", "animation"],
};
</script>

<style>
</style>
